import { BLOCK_CLASSES as e } from "../../constants.js";
import { defineAttrs as t } from "../../utils/typed-attrs.js";
const r = t({
  type: { default: "code" }
}), n = {
  inline: !1,
  content: "(hardBreak | text | inline)*",
  attrs: r,
  defining: !0,
  group: "block",
  parseDOM: [{ tag: "pre" }],
  toDOM() {
    return [
      "pre",
      {
        class: `${e.code}`
      },
      0
    ];
  },
  marks: ""
};
export {
  n as codeBlockSpec
};
